import { Route } from "@angular/router";

import { checkIfLoggedInFn, notExternalOrParticipatingEntity } from "../../core/guards";
import { ImportExportObjectType } from "../../shared/constants/enums";
import { viewImportExportPlanPagesGuards } from "./_guards";

export const IMPORT_EXPORT_PLAN_ROUTES: Route[] = [
  {
    path: "import-export-plan",
    canActivate: [checkIfLoggedInFn, notExternalOrParticipatingEntity, ...viewImportExportPlanPagesGuards],
    loadComponent: () =>
      import("../../shared/components/import-export/import-export").then((e) => e.ImportExportComponent),
    data: {
      breadcrumb: "breadcrumbs.plan_import_export",
      title: "breadcrumbs.plan_import_export",
      type: ImportExportObjectType.PLAN,
    },
  },
];
